// Lib
import { classicFormatMaxTwoDigits } from '@/utils/hooks/format/useFormatNumber';

import { SIZE_50 } from '@/lib/gridElements/size';

// Components
import { LineChart } from '@/components/composite/Charts/LineChart';

export const reactionsHistoryConfig = {
    title: 'chart.linkedin.reactions_history',
    margin: { left: -20, right: 25 },
    name: {
        date: 'date',
        value: 'chart.linkedin.reactions_history_name',
        avg: 'chart.linkedin.reactions_history_avg'
    },
    id: 'reactions_history',
    color: {
        value: 'red',
        avg: 'gray'
    },
    tooltipTranslation: {
        token: 'chart.facebook.tooltip_history',
        values: ['date', 'value', 'percentage_evolution']
    },
    valueFormat: classicFormatMaxTwoDigits,
    size: SIZE_50,
    type: 'chart',
    element: LineChart
};
